export class WebStatusRegistro {
    idRegistro : number;
    nrCpf : string;
    idProcesso : number;
    dtStatus : Date;
    idStatus : number;
    nmUsuario : string;
};